import Button from '../common/Button';

function ServiceCTA({ cta }) {
  return (
    <section className="service-section service-cta-section">
      <div className="container">
        <div className="service-cta">
          <div>
            <p className="eyebrow">Next Step</p>
            <h2>{cta.title}</h2>
            <p>{cta.description}</p>
          </div>
          <div className="service-cta__actions">
            <Button href={cta.primaryCta.href}>{cta.primaryCta.label}</Button>
            <Button to={cta.secondaryCta.to} variant="secondary">
              {cta.secondaryCta.label}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceCTA;
